<template>
<div class="wlx-site-manager-wrapper wlx-user-manager">
    <header class="site-manager-head-con" style="padding-top:20px;">
        <el-form :inline="true" size="small">
            <el-form-item>
                <el-input v-model="name" placeholder="请输入姓名" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-select v-model="isCommittee" placeholder="请选择是否为原专委会委员" clearable>
                    <el-option label="是" value="0"></el-option>
                    <el-option label="否" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="committeeType" placeholder="请选择委员会类型" clearable>
                    <el-option v-for="(item,index) in committee" :key="index" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="season()">搜索</el-button>
            </el-form-item>
        </el-form>
    </header>
    <el-table :data="siteList">
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column prop="sex" label="性别">
            <template slot-scope="scope">
                <span v-if="scope.row.sex == 0">男</span>
                <span v-if="scope.row.sex == 1">女</span>
            </template>
        </el-table-column>
        <el-table-column prop="company" label="单位"></el-table-column>
        <el-table-column prop="job" label="职务/职称"></el-table-column>
        <el-table-column label="是否为原专委会委员">
            <template slot-scope="scope">
                <span v-if="scope.row.isCommittee == 0">是</span>
                <span v-if="scope.row.isCommittee == 1">否</span>
            </template>
        </el-table-column>
        <el-table-column label="委员会类型">
            <template slot-scope="scope">
                <span>{{committee[scope.row.committeeType-1].label}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号"></el-table-column>
        <el-table-column prop="phone" label="账号"></el-table-column>
        <el-table-column prop="dateCreated" label="创建时间"></el-table-column>
        <el-table-column label="操作">
            <template slot-scope="scope">
                <el-button icon="wl-icon-chakan" size="mini" type="primary" @click="goLook(scope.row.id)"></el-button>
            </template>
        </el-table-column>
    </el-table>
    <div class="u-page-con">
        <el-pagination background @size-change="handleSizeChange" @current-change="onPageChangeHandler" :current-page="page" :page-sizes="[10, 20, 50, 100,200,500,1000]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount" v-show="totalCount>0" style="text-align: center;"></el-pagination>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            page: 1,
            pageSize: 10,
            totalCount: 0,
            siteList: [],
            name: "",
            committee: [{
                    label: '教学改革专业委员会',
                    value: '1'
                },
                {
                    label: '技能开发专业委员会',
                    value: '2'
                },
                {
                    label: '校企合作专业委员会',
                    value: '3'
                },
                {
                    label: '国际合作专业委员会',
                    value: '4'
                },
                {
                    label: '信息化专业委员会',
                    value: '5'
                },
                {
                    label: '师资建设专业委员会',
                    value: '6'
                },
            ],
            committeeType: '',
            isCommittee: ''
        };
    },
    components: {},

    created() {
        this.getSessionStorage();
        this.getCommitteeList();

    },
    methods: {
        goLook(id) {
            debugger;
            this.$router.push({
                name: "committeeDetail",
                params: {
                    committeeId: id
                }
            });
        },
        handleSelectionChange() {},
        handleSizeChange(val) {
            this.page = 1;
            this.pageSize = val;
            this.getCommitteeList();
        },
        onPageChangeHandler(val) {
            this.page = val;
            this.getCommitteeList();
        },
        season() {
            this.page = 1;
            this.getCommitteeList();
        },
        // getPilotList(){},
        getCommitteeList() {
            var that = this;
            this.$http
                .post("/api/XOrg/Committee/getCommitteeList", {
                    name: that.name,
                    isCommittee: that.isCommittee,
                    committeeType: that.committeeType,
                    PageSize: that.pageSize,
                    page: that.page
                })
                .then(rst => {
                    that.siteList = rst.list;
                    that.page = rst.pagination.pageIndex;
                    that.pageSize = rst.pagination.pageSize;
                    that.totalCount = rst.pagination.totalCount;

                    // 参数存储本地缓存
                    sessionStorage.setItem("wlx_committee_name", that.name);
                    sessionStorage.setItem("wlx_committee_isCommittee", that.isCommittee);
                    sessionStorage.setItem("wlx_committee_committeeType", that.committeeType);
                    sessionStorage.setItem("wlx_committee_page", that.page);
                    sessionStorage.setItem("wlx_committee_pageSize", that.pageSize);
                });
        },
        // 获取网页缓存信息
        getSessionStorage() {
            // 获取网页缓存信息
            var name = sessionStorage.getItem("wlx_committee_name");
            var isCommittee = sessionStorage.getItem("wlx_committee_isCommittee");
            var committeeType = sessionStorage.getItem("wlx_committee_committeeType");
            var page = sessionStorage.getItem("wlx_committee_page");
            var pageSize = sessionStorage.getItem("wlx_assessmentApplye_pageSize");

            if (name != null && name != undefined && name != "null" && name != 'undefined') {
                this.name = name;
            }
            if (isCommittee != null && isCommittee != undefined && isCommittee != "null" && isCommittee != 'undefined') {
                this.isCommittee = isCommittee;
            }
            if (committeeType != null && committeeType != undefined && committeeType != "null" && committeeType != 'undefined') {
                this.committeeType = committeeType;
            }
            if (page != null && page != undefined) {
                this.page = Number(page);
            }
            if (pageSize != null && pageSize != undefined) {
                this.pageSize = Number(pageSize);
            }
        },
    }
};
</script>

<style lang="scss">
.yk-wrap-fixed {
    .el-input--suffix .el-input__inner {
        padding-right: 30px;
        height: 34px;
    }

    .wl-pagination-text {
        text-align: center;
        margin-top: 30px;
    }

    .site-manager-head-con {
        text-align: right;
    }

    .el-form-item__content {
        .el-button {
            padding: 8px 15px;
        }
    }
}

.wlx-site-manager-wrapper {
    .export-button-a {
        padding: 9px 15px;
        background-color: #409EFF;
        font-size: 12px;
        border-radius: 3px;
    }
}

.wlx-user-manager {
    padding-left: 30px;
}
</style>
